import { render, staticRenderFns } from "./AppStat.vue?vue&type=template&id=2392cf67&scoped=true&"
import script from "./AppStat.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppStat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppStat.vue?vue&type=style&index=0&id=2392cf67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392cf67",
  null
  
)

export default component.exports